import { placementRepository } from '~/api/repository/placement';

export const PLACEMENT_QUERY_KEY = {
  all: ['placement'] as const,

  // GNB 네비게이션 바 조회
  navigationBars: (businessId: number) => ({
    queryKey: [
      '/api/market-place/v1/placements/navigation-bars-new',
      businessId,
    ] as const,
    queryFn: () => placementRepository.getNavigationBars(businessId),
  }),
};
